import React from "react";
import housingIcon from "../../PicesForPages/equal-housing-opportunity-logo-100-w.png";
// import housingIcon from "../../PicesForPages/equal-housing-opportunity-logo-100-w2.png";
import whatappIcon from "../../PicesForPages/WhatsappIcon.png";
import Logo from "../../PicesForPages/logoClient-removebg-preview.png.jpeg";
import { Link } from "react-router-dom";

function Footer() {
  // Scroll to the top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll
    });
  };
  return (
    <div className="footerParent">
      <div className="footerBox">
        <div className="footerTop">
          <div className="footerTopDiv footerTopDiv01">
            <span className="footerTopDivHeading">
              {" "}
              <img
                fetchPriority="high"
                loading="eager"
                src={Logo}
                alt="Logo"
                className="footerLogo"
              />{" "}
              About Us
            </span>

            {/* <span className='footerTopDivContent footerTopDivContent00'>We strive to deliver the highest <br />levels of service to help you <br />reach your goals. We thank you <br />for your trust and support. <br />From the first call to closing, <br />our team is with you every step <br />of the way!</span> */}
            <span className="footerTopDivContent footerTopDivContent00 footerTopDivContent01">
              We are committed to delivering exceptional service to help you
              achieve your goals. We truly appreciate your trust and support.
              From your first call to closing, our team is with you every step
              of the way.
            </span>
          </div>
          <div className="footerTopDiv footerTopDiv01">
            <span className="footerTopDiv footerTopDiv00">
              <span className="footerTopDivHeading">Connect With Us</span>
              <span className="footerTopDivContent footerTopDivContentSM">
                <a
                  href="https://www.facebook.com/VidhiMortgage/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="ri-facebook-box-fill"></i>
                </a>

                <a
                  href="https://www.instagram.com/vidhimortgage"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="ri-instagram-fill"></i>
                </a>

                <a
                  href="https://www.linkedin.com/company/vidhimortgage/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="ri-linkedin-box-fill"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@vidhimortgage"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="ri-tiktok-fill"></i>
                </a>
                <a
                  href="https://www.youtube.com/@VidhiMortgage"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="ri-youtube-fill"></i>
                </a>
              </span>
            </span>
            <span className="footerTopDiv footerTopDiv00 ">
              <span className="footerTopDivHeading">Contact Us</span>
              <span className="footerTopDivContent footerTopDivContent00">
                <a
                  href="https://maps.app.goo.gl/N39ChHDfbcTXj2Fs6"
                  target="_blank"
                  rel="noreferrer"
                  className="footerTopDivContentIcon"
                >
                  <i class="ri-map-pin-line"></i>{" "}
                  <span>
                    5714 Dorrington St, <br />
                    Lewis Center OH 43035
                  </span>
                </a>
                <a
                  href="tel:+1-(614) 397-1676"
                  className="aTag_Tel footerTopDivContentIcon"
                >
                  <i class="ri-phone-fill"></i> <span>(614) 397-1676</span>
                </a>
                <a
                  href="mailto: contact@vidhimortgage.com"
                  className="aTag_Mail footerTopDivContentIcon"
                >
                  <i class="ri-mail-send-fill"></i>{" "}
                  <span>contact@vidhimortgage.com</span>
                </a>
              </span>
            </span>
          </div>
          <div className="footerTopDiv">
            <span className="footerTopDivHeading">Loan Options</span>
            <span className="footerTopDivContent footerTopDivContent00">
              <Link
                to="/which-loan-is-right-for-me"
                onClick={scrollToTop}
                className="LoanOption LoanOption01"
              >
                Fixed Rate Mortgage
              </Link>
              <Link
                to="/fha"
                onClick={scrollToTop}
                className="LoanOption LoanOption02"
              >
                FHA Home Loan
              </Link>
              <Link
                to="/va-loans"
                onClick={scrollToTop}
                className="LoanOption LoanOption03"
              >
                VA Home Loan
              </Link>
              <Link
                to="/which-loan-is-right-for-me"
                onClick={scrollToTop}
                className="LoanOption LoanOption04"
              >
                Jumbo Home Loan
              </Link>
              <Link
                to="/which-loan-is-right-for-me"
                onClick={scrollToTop}
                className="LoanOption LoanOption05"
              >
                First Time Home Buyer
              </Link>
              <Link
                to="/which-loan-is-right-for-me"
                onClick={scrollToTop}
                className="LoanOption LoanOption06"
              >
                Investment Property Loans
              </Link>
              <Link
                to="/refinancing"
                onClick={scrollToTop}
                className="LoanOption LoanOption07"
              >
                Refinance
              </Link>
              <Link
                to="/licenses-disclosures"
                onClick={scrollToTop}
                className="LoanOption LoanOption07"
              >
                Licenses & Disclosures
              </Link>
            </span>
          </div>
          <div className="footerTopDiv">
            <span className="footerTopDivHeading">Resources</span>
            <span className="footerTopDivContent footerTopDivContent00">
              <Link
                to="/contact-us"
                onClick={scrollToTop}
                className="Resource Resource01"
              >
                Contact Us
              </Link>
              <Link
                to="quick-quote"
                onClick={scrollToTop}
                className="Resource Resource02"
              >
                Get A Quote
              </Link>
              <Link
                to="https://vidhimortgage.my1003app.com/"
                target="_blank"
                onClick={scrollToTop}
                className="Resource Resource04"
              >
                Apply Online
              </Link>
              <Link
                to="/testimonials"
                onClick={scrollToTop}
                className="Resource Resource05"
              >
                Reviews
              </Link>
              <Link
                to="https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/2812139"
                target="_blank"
                onClick={scrollToTop}
                className="Resource Resource06"
              >
                NMLS Consumer Access
              </Link>
              <Link
                to="/ada-accessibility-statement"
                onClick={scrollToTop}
                className="Resource Resource07"
              >
                ADA Accessibility Statement
              </Link>
              <Link
                to="/privacy-policy"
                onClick={scrollToTop}
                className="Resource Resource03"
              >
                Privacy Policy
              </Link>
            </span>
          </div>
        </div>
        <div className="footerMiddle">
          <span className="houseIconBox">
            <img
              fetchPriority="high"
              loading="eager"
              src={housingIcon}
              alt="houseIcon"
              className="houseIcon"
            />
            <b>Equal Housing Opportunity</b>
          </span>

          <span> VIDHI MORTGAGE LLC </span>
          <span className="removeOne"> | </span>
          <span>Company NMLS: 2812139</span>
        </div>
        <div className="footerBottom">
          <span>Licensed in FL, OH & TX States.</span>
          <span className="footerBottomDown">
            <b>
              Powered by{" "}
              <a href="https://staiminds.com/" className="shushankTechLink">
                ST AI Minds
              </a>
            </b>
            <span className="footerBottomDown02">
              This site is protected by{" "}
              <a href="https://staiminds.com/" className="shushankTechLink">
                ST AI Minds
              </a>{" "}
              <b>Privacy Policy</b> and <b>Terms of Service</b> apply.
            </span>
          </span>
        </div>
        <a
          href="https://www.linkedin.com/in/pandugayala-raja-naresh-b15b4986/"
          className="Developer"
          target="_blank"
          rel="noreferrer"
        >
          Crafted by: Pandugayala Raja Naresh | Web Developer
        </a>
        <div className="goTop" onClick={scrollToTop}>
          <span>TOP</span>
        </div>
        <div className="WhatApp">
          <a
            href="https://wa.link/9x6eha"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatappIcon}
              alt="whatappIcon"
              className="whatappIcon"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
